import dayjs from 'libraries/dayjs'
import DateFormatter from "../../libraries/dateFormatter";

// SelectedDateRange is a "Tuple"
// Index [0] holds the selected no. of date
// Index [1] holds the translated displayed string of the dates
// Index [2] holds the start timestamp
// Index [3] holds the end timestamp
export type SelectedDateRange = [number, string, number, number];

export enum dateRangeIdx {
  dateRangeName = 1,
  startTimeStamp = 2,
  endTimeStamp = 3,
}

const now = dayjs();

export const dateRanges: SelectedDateRange[] = [
  [
    0,
    "webapp.new_dashboard.date_range.options.today",
    DateFormatter.formatTimestamp(dayjs(now).startOf("day")),
    DateFormatter.formatTimestamp(dayjs(now)),
  ],
  [
    7,
    "webapp.new_dashboard.date_range.options.last_seven_days",
    DateFormatter.formatTimestamp(dayjs(now).subtract(7, "days")),
    DateFormatter.formatTimestamp(dayjs(now)),
  ],
  [
    30,
    "webapp.new_dashboard.date_range.options.last_thirty_days",
    DateFormatter.formatTimestamp(dayjs(now).subtract(30, "days")),
    DateFormatter.formatTimestamp(dayjs(now)),
  ],
  [
    90,
    "webapp.new_dashboard.date_range.options.last_ninety_days",
    DateFormatter.formatTimestamp(dayjs(now).subtract(90, "days")),
    DateFormatter.formatTimestamp(dayjs(now)),
  ],
];

export const initialDateRangeIndex = 1;
